
import { Inject, Injectable, Renderer2, RendererFactory2, DOCUMENT } from '@angular/core';
import { catchError, Observable, of, ReplaySubject, Subject } from 'rxjs';
import { environment } from 'src/environments/environment.staging';

@Injectable({
  providedIn: 'root'
})
export class GoogleMapsService {

  private renderer: Renderer2;
  private scriptLoaded$ = new ReplaySubject<boolean>();
  private isLoading = false;

  constructor(
    @Inject(DOCUMENT) private document: Document, rendererFactory: RendererFactory2
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  /**
   * Método para carregar o script do Google Maps dinamicamente
   */
  public loadGoogleMapsScript(): Observable<boolean> {

    if ((window as any).google?.maps) {
      return of(true);
    }

    if (this.isLoading) {
      return this.scriptLoaded$.asObservable();
    }

    this.isLoading = true;

    const script = this.renderer.createElement('script');

    this.renderer.setAttribute(script, 'id', 'google-maps-script');
    this.renderer.setAttribute(script, 'async', 'true');
    this.renderer.setAttribute(script, 'defer', 'true');

    script.src = environment.googleMapsApiKeyUrl;

    script.onload = () => {
      this.scriptLoaded$.next(true);
      this.scriptLoaded$.complete();
    };

    script.onerror = () => {
      this.scriptLoaded$.error('Erro ao carregar Google Maps');
    };

    // Anexa o script ao cabeçalho (head)
    this.renderer.appendChild(this.document.head, script);

    return this.scriptLoaded$.asObservable();
  }
}
